import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router'
import { UserAuthService } from './user-auth.service'
import { Observable, from, of } from 'rxjs'
import { first, switchMap, map, catchError } from 'rxjs/operators'
import { StateService } from '../common/services/state.service'
import { CommonService } from '../common/services/common.service'
import { fetchAuthSession } from 'aws-amplify/auth'

@Injectable({
  providedIn: 'root'
})
export class AccessToDashboardGuard {
  constructor (private router: Router, private authService: UserAuthService, private stateService: StateService, private commonService: CommonService) {}

  canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.commonService.clearAgentSession()
    return from(fetchAuthSession()).pipe(switchMap((session: any) => {
        if (!session?.tokens?.idToken) {
          return of(state.url !== '/login-initiate' ? this.router.parseUrl('/login-initiate') : true)
        }
        return this.stateService.userDetails.pipe(first(), switchMap((userDetails) => {
            if (Object.keys(userDetails || {})?.length) {
              return of(['/dashboard', '/my-profile'].includes(state.url) ? true : this.router.parseUrl('/dashboard'))
            }
          return this.authService.getUserDetails().pipe(
            first(),
            map(userInfo => this.handleUserInfo(userInfo, state.url)),
            catchError(() => of(this.router.parseUrl('/server-error')))
          )
          })
        )
      }),
      catchError(() => {
        return of(state.url !== '/login-initiate' ? this.router.parseUrl('/login-initiate') : true)
      })
    )
  }
  private handleUserInfo (userInfo: any, url: string): boolean | UrlTree {
    const cleanUrl = url.split('?')[0]
    const allowedPaths = ['/dashboard', '/my-profile']

    if (userInfo?.statusCode === 200 && userInfo?.body?.items?.length > 0) {
      this.stateService.userDetails.next(userInfo.body.items[0])
      return allowedPaths.includes(cleanUrl)
        ? true
        : this.router.parseUrl('/dashboard')
    }
    return this.router.parseUrl('/register')
  }
}
